<template>
  <b-container class="text-center tq-narrow py-4">
    <h1>Thank you!</h1>
    <img
      class="d-block mx-auto my-4"
      src="../assets/logo_smile.svg"
      alt
      width="250"
      height="250"
    />
    <p class="text-muted text-small">
      ... the longer you look, the creepier it gets ...
    </p>
    <p>Every little bit helps and is much appreciated :)</p>
    <p>
      You can check the donation status
      <router-link to="/donations">here</router-link>, but please note that I
      need to update that manually, so it might take a few minutes or hours.
    </p>
  </b-container>
</template>

<script>
export default {
  name: "Donated"
};
</script>

<style scoped>
.tq-narrow {
  max-width: 400px;
}
</style>
